import * as React from 'react';

import { LoadingWolf, VStack } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

import { useMediaQuery } from '@packages/hooks/use-media-query';

export const FullScreenLoader: React.FC = React.memo(() => {
  const { t } = useTranslation('ui');
  const isReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');

  return (
    <VStack
      xAlign="center"
      css={{
        height: '100vh',
      }}
    >
      <LoadingWolf isLoading={!isReducedMotion} caption={t('loader.caption')} />
    </VStack>
  );
});

/**
 * Used in React.Suspense, it must not depend on `useTranslation`.
 */
export const FullScreenLoaderFallback: React.FC = React.memo(() => {
  const isReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');

  return (
    <VStack
      xAlign="center"
      css={{
        height: '100vh',
      }}
    >
      <LoadingWolf isLoading={!isReducedMotion} />
    </VStack>
  );
});
